var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.componentId,{tag:"component",attrs:{"fetched-data":_vm.fetchedData,"block":_vm.block}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }